/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Component, EventEmitter, forwardRef, Input, Output } from "@angular/core";
import { AbstractControlValueAccessorControl } from "@irian-ro/shared-components-module";
import { PersonAutocompleteVoModel } from "./person-autocomplete-vo.model";
import { PersonAutocompleteService } from "./person-autocomplete.service";
import { FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR } from "@angular/forms";

@Component({
  selector: 'well-person-autocomplete',
  templateUrl: './person-autocomplete.component.html',
  styleUrls: ['./person-autocomplete.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PersonAutocompleteComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => PersonAutocompleteComponent),
      multi: true
    }
  ]
})
export class PersonAutocompleteComponent extends AbstractControlValueAccessorControl {

  @Input() placeholder: string | null = null;
  @Input() disabled = false;

  @Output() personSelect: EventEmitter<PersonAutocompleteVoModel> = new EventEmitter();

  results: PersonAutocompleteVoModel[] = [];

  constructor(private personAutocompleteService: PersonAutocompleteService) {
    super();
  }

  onQueryChange(query: string) {
    const queryObj = {
      filters: {
        filterQuery: {
          value: query,
          matchMode: 'contains'
        }
      }
    };

    this.personAutocompleteService.findAll(queryObj).subscribe(res => {
      this.results = res;
    });
  }

  onSelectItem(item: PersonAutocompleteVoModel) {
    this.form?.patchValue(item);
    this.personSelect.next(item);
  }

  protected createForm() {
    this.form = new FormControl(null);
  }

  writeValue(obj: any): void {
    this.form?.patchValue(obj);
  }

  getDisplayName = (item: PersonAutocompleteVoModel | null): string => {
    return item?.name ?? '';
  };

  compareByUuid = (a: PersonAutocompleteVoModel, b: PersonAutocompleteVoModel): boolean => {
    return a?.uuid === b?.uuid;
  };
}
